var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-field',{attrs:{"label":_vm.label,"type":_vm.error ? 'is-danger' : _vm.type,"message":_vm.message}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }